/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.insights.rpc.UserInsightsChirpService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getUserInsightsRpc = {
  serviceName: 'com.hubspot.marketplace.insights.rpc.UserInsightsChirpService',
  rpcName: 'getUserInsights',
  auth: 'external',
  fingerprint: 'jeQ6C_HiowEkDuhZzrMBhJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};